import React from 'react'

const ManageTeams = () => {
  return (
    <div
    style={{
        display: "flex",
        backgroundColor: "#F5F7FA", 
        height: "100vh", 
        flexDirection: "column"
      }}>
      Manage Teams
    </div>
  )
}

export default ManageTeams
